import React, { useEffect, useState } from 'react'

import 'react-multi-carousel/lib/styles.css'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import { ClientForm } from './ClientForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'
// Pridané importy
import { useAuth } from '../common/Auth'
import { fetchClients } from '../common/helpers'
import { Package } from '../types/gopay'

function ClientsAddPage() {
    const {t} = useTranslation()
    const auth = useAuth()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        fetchClients().then((clients) => {
            const currentCount = clients.length
            const userPackage = auth.user?.selectedPackage

            let limit = 0
            switch (userPackage) {
                case Package.FREE:
                    limit = 0
                    break
                case Package.BASIC:
                    limit = 3
                    break
                case Package.MEDIUM:
                    limit = 7
                    break
                case Package.PREMIUM:
                    limit = 99999
                    break
                default:
                    limit = 0
            }

            if (currentCount >= limit) {
                toast.error(t('max_clients_reached', {pkg: userPackage || 'Unknown'}))
                navigate('/app/clients')
            } else {
                setLoading(false)
            }
        }).catch((err) => {
            console.error(err)
            setLoading(false)
        })
    }, [auth.user, navigate])

    if (loading) {
        return <AppLayout>{t('loading')}</AppLayout>
    }

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/clients' }><button className="btn amani-primary">{t('back')}</button></Link>}>{t('add_client')}</AppTitle>

            <ClientForm/>
        </AppLayout>
    )
}

export default ClientsAddPage